// This file is manually curated to allow us to expose the generated
// client as we like.
//
// Every helper goes through create() so omitted scalars get their proto3 defaults. Stamping
// $typeName by hand instead makes connect's own create() treat the object as already built and
// skip the defaults, which is what left cursor undefined and crashed JSON encoding.
import { create } from "@bufbuild/protobuf";
import { Auth, Chat, Realm } from "./gen";

// =============================================================================
// AUTH
// =============================================================================
export function createAuthSyncRequest(data: Partial<Omit<Auth.SyncRequest, "$typeName">> = {}): Auth.SyncRequest {
  return create(Auth.SyncRequestSchema, data);
}

// =============================================================================
// REALMS
// =============================================================================
export function createRealmWithNames(
  data: Partial<Omit<Realm.RealmWithNames, "$typeName">> = {}
): Realm.RealmWithNames {
  return create(Realm.RealmWithNamesSchema, data);
}

// =============================================================================
// Chat
// =============================================================================
export function createListRecentChatsRequest(
  data: Partial<Omit<Chat.ListRecentChatsRequest, "$typeName">> = {}
): Chat.ListRecentChatsRequest {
  return create(Chat.ListRecentChatsRequestSchema, data);
}

export function createInterruptChatRequest(
  data: Partial<Omit<Chat.InterruptChatRequest, "$typeName">> = {}
): Chat.InterruptChatRequest {
  return create(Chat.InterruptChatRequestSchema, data);
}

export function createConversationRequest(
  data: Partial<Omit<Chat.ConversationRequest, "$typeName">> = {}
): Chat.ConversationRequest {
  return create(Chat.ConversationRequestSchema, data);
}
